import { SignInPage } from './SignInPage';

export default SignInPage;